import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import AutoSuggest from 'react-autosuggest';
import { SearchOutlined } from '@ant-design/icons';
import { MAX_SEARCH_QUERY_LENGTH } from 'constants/common';
import { useStores } from 'stores';
import { safeDecode } from '../../../../helpers/utils';
import styles from './SuggestionSearch.module.scss';

const SuggestionSearch = (props: any) => {
  const { singleLotStore, lotStore } = useStores();
  const { setTag, onFilterChange, setDefaultPageNumber } = props;
  const { tags, getTags } = singleLotStore;
  const {
    filters: { query },
  } = lotStore;

  const [inputValue, setInputValue] = useState<string>('');
  const [suggestions, setSuggestions] = useState<any[]>([]);

  useEffect(() => {
    const decoded = safeDecode(query) || '';
    const truncated = decoded.slice(0, MAX_SEARCH_QUERY_LENGTH);
    setInputValue(truncated);
    if (decoded.length > MAX_SEARCH_QUERY_LENGTH) {
      onFilterChange([{ name: 'query', value: truncated }]);
    }
  }, [query, onFilterChange]);

  useEffect(() => {
    getTags();
  }, []);

  const getTagId = (suggestionValue: string) =>
    tags.find(tag => tag.name.toLowerCase() === suggestionValue.toLowerCase())?.id;

  const renderSuggestedTags = (tag: any) => tag.name;

  const renderSuggestionsContainer = (container: any) => (
    <div {...container.containerProps}>
      <div>
        <span>Search by tag:</span>
        {container.children}
      </div>
    </div>
  );

  const getSuggestions = (value: string) => {
    const inputValue = value.trim().toLowerCase();
    const inputValueLength = inputValue.length;

    return inputValueLength === 0
      ? []
      : tags.filter(initTag => initTag.name.toLowerCase().slice(0, inputValueLength) === inputValue);
  };

  const onSuggestionsFetchRequested = ({ value }: { value: string }) => setSuggestions(getSuggestions(value));

  const onSuggestionsClearRequested = () => setSuggestions([]);

  const getSelectedTagValue = (tag: any) => tag.name;

  const handleSearchInput = (value: string) => {
    const truncated = value.slice(0, MAX_SEARCH_QUERY_LENGTH);
    onFilterChange([{ name: 'query', value: truncated }]);
    setInputValue(truncated);
  };

  const handleSaveCheckedTags = (suggestionValue: any) => {
    setDefaultPageNumber();
    lotStore.setDefaultPage();
    setTag(getTagId(suggestionValue));
    handleSearchInput('');
  };

  return (
    <div className={styles.bns3_search_container}>
      <div className={styles.bns3_search_wrapper}>
        <SearchOutlined />
        <AutoSuggest
          data-testid="search-button"
          suggestions={suggestions}
          onSuggestionsFetchRequested={onSuggestionsFetchRequested}
          onSuggestionsClearRequested={onSuggestionsClearRequested}
          getSuggestionValue={getSelectedTagValue}
          renderSuggestion={renderSuggestedTags}
          renderSuggestionsContainer={renderSuggestionsContainer}
          onSuggestionSelected={(_, { suggestionValue }) => {
            handleSaveCheckedTags(suggestionValue);
          }}
          inputProps={{
            maxLength: MAX_SEARCH_QUERY_LENGTH,
            placeholder: 'Search',
            value: inputValue,
            onChange: (_, { newValue }) => setInputValue(newValue),
            onKeyDown: event => {
              if (event.key === 'Enter') {
                handleSearchInput(inputValue);
              }
            },
            type: 'search',
          }}
          theme={styles}
        />
      </div>
    </div>
  );
};

export default observer(SuggestionSearch);
